import { render } from "./Magazzino.vue?vue&type=template&id=75df4e6c"
import script from "./Magazzino.vue?vue&type=script&lang=js"
export * from "./Magazzino.vue?vue&type=script&lang=js"

import exportComponent from "C:\\DEV\\SHIRE\\nic\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__